import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

/** Workspace feature flag AND per-user manage permission. */
export const canManageSignalsApi = (): boolean =>
    salesSettingsHelper.isSalesApiSignalsEnabled && salesSettingsHelper.hasApiSignalsAccess();

export const canManageSavedSearchWebhooks = (): boolean =>
    salesSettingsHelper.isSavedSearchWebhooksEnabled && salesSettingsHelper.hasAccessToManageSavedSearchWebhooks;
